import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';
import {theme} from '../lib/theme';

const StyledError = styled.div`
  width: calc(100% - 32px);
  max-width: 500px;
  border-radius: 10px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 8;
  padding: 0 20px 20px 20px;
  text-align: left;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
  height: auto;
  > div {
    width: 100%;
    float: left;

    &:first-child {
      h2 {
        font-family:'Helvetica Neue LT W01_35 Thin';
        font-size: 2em;
        padding-right: 70px;
        color: ${props => props.theme.red};
      }
      span {
        font-size: .625em;
        color: #999;
        text-transform: uppercase;
      }
      > button {
        position: absolute;
        right: 20px;
        top: 36px;
        display: block;
        font-size: 1em;
        span {
          margin-right: 20px;
          line-height: 1.4;
          vertical-align: top;
          display: none;
          @media (min-width: 640px) {
            display: block;
          }
        }
        i {
          margin: 2px 0 0 1em;
          width: 10px;
          height: 10px;
          float: right;
          svg {
            stroke: #000;
            stroke-width: 2;
          }
        }
      }
    }

    &:last-child {
      button {
        width: 220px;
        height: 40px;
        justify-content: center;
        margin: 2em auto;
      }
    }
  }
`;

export default function Error (props) {
  const {toggleLayer, error} = props;
  return (
    <StyledError>
      <div>
        <h2>{"Sorry, an error occured"}</h2>
        <span>({error})</span>
        <Button icon="close" label="close" transparent onClick={toggleLayer}/>
      </div>
      <div>
        <p>Please try again later.</p>
      </div>
      <div>
        <Button label="close" rounded blueBright onClick={toggleLayer}/>
      </div>
    </StyledError>
  )
}

Error.propTypes = {
  toggleLayer: PropTypes.func,
  error: PropTypes.string,
};
